import { ArrowPathIcon, XCircleIcon } from '@heroicons/react/24/outline';
import Button from '../../shared/buttons/button';
import Modal from '../../shared/modals/modal';

export type BehaviorStateModalPropsType = {
  showModal: boolean;
  onClose: () => void;
};

function BehaviorStateModal({ showModal, onClose }: BehaviorStateModalPropsType) {
  return (
    <Modal
      showModal={showModal}
      onClose={onClose}
      header='وضعیت نشان‌ها'
      footer={<Button color='green' content='تایید' className='ms-auto' onClick={onClose} />}
    >
      <div className='mx-2 mt-2 flex flex-col gap-4 leading-8'>
        <div>
          <p>
            <ArrowPathIcon width={21} height={21} className='inline text-blue-500' />
            <span className='font-bold'> : برمی‌گردم!</span>
          </p>
          <p className='text-sm'>سوالاتی که شک دارید یا زمان بیشتری برای پاسخگویی نیاز دارید.</p>
        </div>
        <div>
          <p>
            <XCircleIcon width={24} height={24} className='inline text-red-500' />
            <span className='font-bold'> : ولش کن!</span>
            <p className='text-sm'>سوالاتی که بلد نیستید و نمی خواهید برایشان وقت بگذارید.</p>
          </p>
        </div>
        <div className='mt-2 text-sm'>
          <p className='font-bold'>نکات مهم:</p>
          <p>1. در صورتی که یکی از گزینه‌های سوال را انتخاب کنید، این وضعیت‌ها غیر‌فعال می‌شوند.</p>
          <p>
            2. هر‌کدام از این وضعیت‌ها را که انتخاب کنید، قابل تغییر به وضعیت دیگر است و محدودیتی در
            تغییر وضعیت سوال وجود ندارد.
          </p>
        </div>
      </div>
    </Modal>
  );
}

export default BehaviorStateModal;
